<template>
  <div id="subscribe" class="bg-lightest-orange w-full lg:flex px-14 lg:px-50 xl:px-20">
    <div class="grid lg:grid-cols-2 container">
      <div class="py-30 lg:py-30 lg:pr-30 xl:py-50 xl:pr-50 order-2 lg:order-none">
        <div class="flex flex-col justify-between">
          <div class="w-full mb-16 lg:mb-30">
            <p class="text-xl lg:text-32 mb-16 font-display font-bold leading-normal">Discover your
              art,<br/>
              discover drybrush Gallery</p>
            <p class="text-base leading-tight">Never miss an art update. Subscribe now for the latest news, trends, and
              creative inspirations.</p>
          </div>
          <div class="w-full flex items-center">
            <form @submit.prevent="submitData" class="w-full">
              <div class="w-full form-group mb-16 lg:mb-20">
                <input type="email" id="email" v-model="email" placeholder="Email Address"
                  class="w-full px-24 py-14 rounded-full border border-light-gray-2 outline-none" required />
              </div>
              <button type="submit" class="btn btn-primary-black w-full lg:w-fit">Subscribe Now
                <i class="far fa-mailbox ml-4"></i>
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="order-1 lg:order-none">
        <img src="../../../assets/images/subscription-panel.png" alt="Subscription Panel"
          class="w-full h-full object-cover" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      api: '/web/api/subscriptions/subscribe',
      email: '',
    }
  },

  methods: {
    submitData() {
      axios.post(this.api, { email: this.email })
        .then(({ data: { data } }) => {
          this.$root.$refs.notification.notify({
            title: 'Success',
            message: data.message,
            type: 'warning-dark',
          })
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.$root.$refs.notification.notify({
              title: 'Error',
              message: error.response.data.errors.email[0],
              type: 'warning-dark',
            })
          }
        })
    }
  }
};
</script>

<!-- <style>
@import "../../../css/components/wavy-border.css";
</style> -->
